import type { GuideSlice } from '../bs/guide'

/**
 * Serbian overrides for the guide screen.
 *
 * One entry, and it is the whole of the difference: *mijenja* → *menja*.
 * *Uputstvo* is the Serbian word as much as the Bosnian one — this is where
 * Serbian and Croatian part company rather than Serbian and Bosnian — so the
 * labels are inherited untouched and only the jat reflex moves.
 *
 * Latin script, matching the rest of the application.
 */
export const guide: Partial<GuideSlice> = {
  'guide.preview.note':
    'Ovo je uputstvo koje vidi kolega sa ulogom {role}. Vaša uloga se time ne menja — ovo je samo pregled.',
}
